import React from "react";
import CheckableButton from "../../Components/CheckableButton/CheckableButton";
import ButtonContainer from "../../Components/CheckableButton/ButtonContainer";
import ConfirmButton from "../../Components/Buttons/ConfirmButton";
import CancelButton from "../../Components/Buttons/CancelButton";
import FormField from "../../Components/FormField/FormField";
import FormDropdown from "../../Components/FormField/FormDropdown";
import "./Campus.css";
import { notify } from "react-notify-toast";
import Modal from "../../Components/Modal/Modal";
import TimePicker from '@bit/nexxtway.react-rainbow.time-picker';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { connect } from "react-redux";
import { updateClass, deleteClass } from "../../redux/college/college.actions";
import { API } from "../../API";
import { getClass, getClassCategories } from "../../Helper";

const classListFull = getClass();
const classListGE = classListFull.filter(cl => cl.type.includes("ge") && cl.key !== "All ELICOS")
  .map(cl => [cl.whole_name, cl.key])
const classListExam = classListFull.filter(cl => cl.type.includes("exam"))
  .map(cl => [cl.whole_name, cl.key])
const classListVET = classListFull.filter(cl => cl.type.includes("vet"))
  .map(cl => [cl.whole_name, cl.key])
// const classListOther = classListFull.filter(cl => cl.type.includes("other"))
//   .map(cl => [cl.whole_name, cl.key])
const vetCategoryList = getClassCategories().filter(cat => cat.type === "vet");
const classListBSB = classListFull.filter(cl => cl.type.includes("bsb"))
  .map(cl => [cl.whole_name, cl.key])
const classListCHC = classListFull.filter(cl => cl.type.includes("chc"))
  .map(cl => [cl.whole_name, cl.key])
const classListFNS = classListFull.filter(cl => cl.type.includes("fns"))
  .map(cl => [cl.whole_name, cl.key])
const classListFSK = classListFull.filter(cl => cl.type.includes("fsk"))
  .map(cl => [cl.whole_name, cl.key])
const classListSHB = classListFull.filter(cl => cl.type.includes("shb"))
  .map(cl => [cl.whole_name, cl.key])
const classListICT = classListFull.filter(cl => cl.type.includes("ict"))
  .map(cl => [cl.whole_name, cl.key])
const classListSIT = classListFull.filter(cl => cl.type.includes("sit"))
  .map(cl => [cl.whole_name, cl.key])
const classListAllVET = [classListBSB, classListCHC, classListFNS, classListFSK, classListSHB, classListICT, classListSIT]
  .map(classList => {
    return classList.sort((a, b) => a[0] > b[0] ? 1 : -1)
  })

class TimetableFormMobile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mobileCla: props.mobileCla,
      // levels: [
      //   [['Beginner/ Starter', 'Beginner'], ['Pre-Intermediate', 'Pre-Intermediate GE'], ['Upper-Intermediate', 'Upper-Intermediate GE'], ['Blended Lower', 'Blended Lower GE'], ['All Levels', 'GE All Levels'], ['All Levels Except Beginner/Starter', 'All ELICOS(Except Beginner/Starter)'], ['Elementary', 'Elementary GE'], ['Intermediate', 'Intermediate GE'], ['Advanced', 'Advanced GE'], ['Blended Upper', 'Blended Upper GE']]
      //   , [['Cambridge English Proficiency', 'Cambridge English Proficiency'], ['Cambridge PET', 'Cambridge PET'], ['Cambridge CAE', 'Cambridge CAE'], ['PTE', 'PTE'], ['IELTS Advanced', 'IELTS Advanced'], ['Cambridge KEY', 'Cambridge KEY'], ['Cambridge FCE', 'Cambridge FCE'], ['IELTS', 'IELTS'], ['IELTS Intermediate', 'IELTS Intermediate'], ['Occupational English Test', 'Occupational English Test']]
      //   , [['EAP', 'EAP'], ['Business English', 'Business English']]
      //   , [['EAL I', 'EAL I'], ['EAL II', 'EAL II'], ['EAL III', 'EAL III'], ['EAL IV', 'EAL IV'], ['CSWE I', 'CSWE I'], ['CSWE II', 'CSWE II'], ['CSWE III', 'CSWE III'], ['CSWE IV', 'CSWE IV']]
      // ],
      levels: [classListGE, classListExam, classListVET].concat(classListAllVET),
      depart_ops: ['ELICOSGE', 'ELICOS_Exam_Preparation', 'VETE',
        "bsb", "chc", "fns", "fsk", "shb", "ict", "sit"],
      session_ops: [["1", "AM"], ["2", "PM"], ["3", "Eve"], ["4", "All day"]],
      days_ops: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
      activecampuses: [],
      fullcontrol: false,
      vetCategory: "bsb"
    }
  }

  handleDeleteClass = (e) => {
    this.props.deleteClass(this.state.mobileCla);
    this.setState({ isShowing: false });
    window.location.reload(false);
  };

  componentDidMount = () => {
    this.setState({
      mobileCla: this.props.mobileCla,
      activecampuses: this.props.campuses.map((campus) => campus._id),
      fullcontrol: this.props.user.permissions ? false : true,
    })
  }

  timeFormat = (old_time) => {
    var new_time = ''
    var olt = old_time.split(":")
    if (olt[0].length == 1) {
      new_time = '0' + olt[0]
    } else {
      new_time = olt[0]
    }
    new_time += ":"
    new_time += olt[1]

    return new_time
  }

  handleSessionChange = (e) => {
    var mobileC = this.state.mobileCla
    mobileC.session = e.target.value
    this.setState({
      mobileCla: mobileC,
    })
    console.log(e.target.value)
  }

  handleLevelChange = (e) => {
    var mobileC = this.state.mobileCla
    // if (mobileC.department == e.target.title) {
    //   if (mobileC.level.indexOf(e.target.value) != -1) {
    //     mobileC.level.splice(mobileC.level.indexOf(e.target.value), 1)
    //   } else {
    //     mobileC.level.push(e.target.value)
    //   }
    // } else {
    //   mobileC.level = [e.target.value]
    // }
    if (mobileC.level.includes(e.target.value)) {
      mobileC.level = mobileC.level.filter(lvl => lvl !== e.target.value)
    }
    else {
      mobileC.level.push(e.target.value)
    }

    this.setState({
      mobileCla: mobileC,
    })
  }

  handleTimeChange = (value, timeslot) => {
    var mobileC = this.state.mobileCla
    mobileC[timeslot] = value
    this.setState({
      mobileCla: mobileC,
    })
  }

  handlePHchange = (e) => {
    var mobileC = this.state.mobileCla
    mobileC.paid_teaching_hours = e.target.value
    this.setState({
      mobileCla: mobileC,
    })
  }

  validate = () => {
    let valid = true
    if (this.state.mobileCla.level.length === 0) {
      valid = false
      notify.show("Please select at least one class level.")
    } else if (this.state.mobileCla.session === 0) {
      valid = false
      notify.show("Please select at least one session for the class.")
    } else if (this.state.mobileCla.arrival_time === ':undefined') {
      valid = false
      notify.show("Please set the arrival time for the class.")
    } else if (this.state.mobileCla.start_time === ':undefined') {
      valid = false
      notify.show("Please set the start time for the class.")
    } else if (this.state.mobileCla.end_time === ':undefined') {
      valid = false
      notify.show("Please set the end time for the class.")
    } else if (this.state.mobileCla.paid_teaching_hours.toString() === '' ||
      this.state.mobileCla.paid_teaching_hours < 3) {
      valid = false
      notify.show("Please enter the paid teaching hours (>= 3) for the class.")
    } else if (this.state.mobileCla.days_of_delivery === '') {
      valid = false
      notify.show("Please enter days of delivery")
    }
    return valid
  }

  handleSubmit = (e) => {
    e.preventDefault();

    if (this.state.mobileCla.department) {

      const valid = this.validate();
      if (valid) {
        this.props.updateClass(this.state.mobileCla._id, this.state.mobileCla);
        API.instProgressEmail({
          inst_id: this.props.institution._id,
          email_address: this.props.user.email,
          etype: "TT_CONF",
        })
        window.location.reload(false);
      }
    } else {
      console.log('No department selected')
      notify.show("Please select a department.")
    }
  }

  handleCampusChange = (e) => {
    var mobileC = this.state.mobileCla
    mobileC.campus_id = e.target.value
    this.setState({
      mobileCla: mobileC,
    })
  }

  handleDaysChange = (e) => {
    var mobileC = this.state.mobileCla
    var dod_list = mobileC.days_of_delivery.split(",")
    if (dod_list.includes(e.target.value)) {
      dod_list.splice(dod_list.indexOf(e.target.value), 1)
    } else {
      dod_list.push(e.target.value)
    }

    mobileC.days_of_delivery = dod_list.toString()

    this.setState({
      mobileCla: mobileC,
    })
  }

  handleCNchange = (e) => {
    var mobileC = this.state.mobileCla
    mobileC.class_note = e.target.value
    this.setState({
      mobileCla: mobileC,
    })
  }

  handleRNchange = (e) => {
    var mobileC = this.state.mobileCla
    mobileC.reference_name = e.target.value
    this.setState({
      mobileCla: mobileC,
    })
  }

  openModal = (e) => {
    this.setState({ isShowing: true });
  }
  closeModal = (e) => {
    this.setState({ isShowing: false });
  }

  defaultCampus = () => {
    var campus = null
    this.props.campuses.forEach(cam => {
      if (this.state.mobileCla.campus_id == cam._id) {
        campus = cam
      }
    })

    if (campus != null) {
      return (
        <option value={campus._id} key={campus._id}>{campus.reference_name}</option>
      )
    }
  }

  handleDepartChange = (e) => {
    var mobileC = this.state.mobileCla
    mobileC.department = e.target.value
    console.log('edited', mobileC)
    this.setState({
      mobileCla: mobileC,
    })
  }

  handleVetCategoryChange = (e) => {
    this.setState({ vetCategory: e.target.value })
  }

  render() {

    return (
      <div className="row college-info">
        <div className="col-lg-6 col-md-12 column-fix">
          <div className="w-100 row flex-row">
            <FormDropdown
              label={this.props.user.is_childcare_centre ? "Select centre for this shift" : "Select campus for this class"}
              id="class-campus"
              className="col-md-6 column-fix"
              onChange={this.handleCampusChange}
              required
            >
              {(this.state.mobileCla == null) ? (<p></p>) : this.defaultCampus()}
              {this.props.campuses.map((campus) => {
                const selectable = this.state.fullcontrol
                  || this.state.activecampuses.filter((item) => { return item === campus._id }).length > 0
                if (campus._id != this.state.mobileCla.campus_id) {
                  return (selectable ?
                    <option value={campus._id} key={campus._id}>
                      {campus.reference_name}
                    </option> :
                    null
                  )
                }
              })}
            </FormDropdown>

          </div>
          <ButtonContainer id={this.state.mobileCla._id} label="Select Departments"
            className="w-100">
            <FormControl component="fieldset">
              <RadioGroup aria-label="department" name="department" onChange={this.handleDepartChange}>
                <FormControlLabel
                  value="ELICOSGE"
                  control={
                    <Radio
                      style={this.state.mobileCla.department == "ELICOSGE" ?
                        ({ color: "rgb(47, 224, 222)" }) : ({ color: "rgb(158, 158, 158)" })} />
                  }
                  style={{ marginBottom: -7 }}
                  label="General English"
                  checked={this.state.mobileCla.department == "ELICOSGE"} />
                <FormControlLabel
                  value="ELICOS_Exam_Preparation"
                  checked={this.state.mobileCla.department == "ELICOS_Exam_Preparation"}
                  control={
                    <Radio
                      style={this.state.mobileCla.department == "ELICOS_Exam_Preparation" ?
                        ({ color: "rgb(47, 224, 222)" }) : ({ color: "rgb(158, 158, 158)" })} />
                  }
                  style={{ marginBottom: -7 }}
                  label="Exam/Assessment-related" />
                <FormControlLabel
                  value="VETE"
                  control={
                    <Radio
                      style={this.state.mobileCla.department == "VETE" ?
                        ({ color: "rgb(47, 224, 222)" }) : ({ color: "rgb(158, 158, 158)" })} />
                  }
                  style={{ marginBottom: -7 }}
                  label="VET English"
                  checked={this.state.mobileCla.department == "VETE"} />
                <FormControlLabel
                  value="VETC"
                  control={
                    <Radio
                      style={this.state.mobileCla.department == "VETC" ?
                        ({ color: "rgb(47, 224, 222)" }) : ({ color: "rgb(158, 158, 158)" })} />
                  }
                  style={{ marginBottom: -7 }}
                  label="Vocational Courses (VET)"
                  checked={this.state.mobileCla.department == "VETC"} />
                {/* <FormControlLabel
                  value="ELICOS_Other"
                  control={
                    <Radio
                      style={this.state.mobileCla.department == "ELICOS_Other" ?
                        ({ color: "rgb(47, 224, 222)" }) : ({ color: "rgb(158, 158, 158)" })} />
                  }
                  label="Other"
                  checked={this.state.mobileCla.department == "ELICOS_Other"} /> */}
              </RadioGroup>
            </FormControl>
          </ButtonContainer>

          <ButtonContainer label="VET Categories" hidden={this.state.mobileCla.department !== "VETC"}>
            <FormControl component="fieldset">
              <RadioGroup aria-label="vet-categories" name="vet-categories" onChange={this.handleVetCategoryChange}>
                {vetCategoryList.map((cat, index) => {
                  return <FormControlLabel
                    value={cat.value}
                    control={
                      <Radio
                        style={this.state.vetCategory === cat.value ?
                          ({ color: "rgb(47, 224, 222)" }) : ({ color: "rgb(158, 158, 158)" })} />
                    }
                    label={cat.name}
                    style={{ marginBottom: index === (vetCategoryList.length - 1) ? 10 : 0 }}
                    checked={this.state.vetCategory === cat.value} />
                })}
              </RadioGroup>
            </FormControl>
          </ButtonContainer>

          {this.state.depart_ops.map((ops) => {
            const index = this.state.depart_ops.indexOf(ops)
            return (
              <div hidden={this.state.mobileCla.department === "VETC" ?
                this.state.vetCategory !== ops
                :
                this.state.mobileCla.department !== ops
              }>
                <ButtonContainer label="Level/class type"
                  className="w-100 row flex-row"
                // hidden={this.state.mobileCla.department !== ops && this.state.vetCategory !== ops}
                >
                  <div className="col-md-6 column-fix">
                    {this.state.levels[index].map((level_ops) => {
                      return (
                        <CheckableButton
                          checkbox
                          id={level_ops[1]}
                          name="class_type"
                          title={ops}
                          value={level_ops[1]}
                          onChange={this.handleLevelChange}
                          checked={
                            this.state.mobileCla.level?.includes(level_ops[1])
                          }
                        >
                          {level_ops[0]}
                        </CheckableButton>
                      )
                    })}
                  </div>
                </ButtonContainer>
              </div>
            )
          })}
        </div>

        <div className="col-lg-6 col-md-12 column-fix">
          <ButtonContainer label="Session" className="w-100 row flex-row" >
            <div className="col-md-3" style={{ textAlign: "left" }}>
              <FormControl component="fieldset">
                <RadioGroup aria-label="session" name="session" onChange={this.handleSessionChange}>
                  {this.state.session_ops.map((se_ops) => {
                    return (
                      <FormControlLabel
                        value={se_ops[0]}
                        control={
                          <Radio
                            style={this.state.mobileCla.session == se_ops[0] ?
                              ({ color: "rgb(47, 224, 222)" }) : ({ color: "rgb(158, 158, 158)" })} />
                        }
                        style={{ marginBottom: -7 }}
                        label={se_ops[1]}
                        checked={this.state.mobileCla.session == se_ops[0]} />
                    )
                  })}
                </RadioGroup>
              </FormControl>
            </div>
          </ButtonContainer>

          <div className="w-100 row flex-row mt-3">
            <div className="col-md-3 column-fix">
              <TimePicker
                label="Arrival time"
                className="timePicker-box"
                onChange={value => this.handleTimeChange(value, "arrival_time")}
                value={this.state.mobileCla.arrival_time}
              />
            </div>
            <div className="col-md-3 column-fix">
              <TimePicker
                label="Start time"
                className="timePicker-box"
                onChange={value => this.handleTimeChange(value, "start_time")}
                value={this.state.mobileCla.start_time}
              />
            </div>
            <div className="col-md-3 column-fix">
              <TimePicker
                label="Finish time"
                className="timePicker-box"
                onChange={value => this.handleTimeChange(value, "end_time")}
                value={this.state.mobileCla.end_time}
              />
            </div>
            <div className="col-md-3 column-fix mt-3">
              <FormField
                label="Paid hours"
                id="paid_hour"
                onChange={this.handlePHchange}
                value={this.state.mobileCla.paid_teaching_hours}
                placeholder="No. of paid hours"
                required
                type="number"
              />
            </div>
          </div>

          <ButtonContainer label="Days of delivery" className="w-100 row flex-row" >
            <div className="col-md-3 column-fix">
              {this.state.days_ops.map((day) => {
                return (
                  <CheckableButton
                    checkbox
                    id={day}
                    name="session-day"
                    title={day}
                    value={day}
                    onChange={this.handleDaysChange}
                    checked={
                      this.state.mobileCla.days_of_delivery.includes(day)
                    }
                  >
                    {day}
                  </CheckableButton>
                )
              })}
            </div>
          </ButtonContainer>

          <div className="w-100 row flex-row">
            <div className="col-md-12 column-fix">
              <FormField
                // type="textarea"
                id="note_gcal"
                label="Permanent instructions/notes"
                value={this.state.mobileCla.class_note}
                placeholder="Enter instructions/notes"
                onChange={this.handleCNchange}>
              </FormField>
            </div>
          </div>
          <div className="w-100 row flex-row">
            <div className="col-md-12 column-fix">
              <FormField
                id="campus_shortname"
                label="Save this class under a nickname"
                maxLength={7}
                required
                placeholder="E.g.: GE.AM (max 7 characters)"
                value={this.state.mobileCla.reference_name}
                onChange={this.handleRNchange}>
              </FormField>
            </div>
          </div>
        </div>

        <div className="row col-md-12 pt-6 column-fix">
          <div className="col-md-12 column-fix">
            <CancelButton
              type="button"
              className="college_delete"
              hidden={!this.props.editclass}
              disabled
            // onClick={this.openModal}
            >
              Delete
            </CancelButton>
          </div>
          <div className="col-md-12 column-fix">
            <ConfirmButton type="submit" className="college_submit"
              hidden={!this.props.editclass} onClick={this.handleSubmit}>
              Submit
            </ConfirmButton>
          </div>

        </div>

        <Modal
          className="confirm-delete"
          header="Do you wish to delete?"
          show={this.state.isShowing}
          onClose={this.closeModal}
        >
          <div className="row m-0">
            <div className="col-md-6">
              <CancelButton
                type="button"
                onClick={this.closeModal}
              >
                Cancel
              </CancelButton>
            </div>
            <div className="col-md-6 padding-for-mobile">
              <ConfirmButton
                type="button"
                onClick={this.handleDeleteClass}
              >
                Yes and Proceed
              </ConfirmButton>
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    institution: state.college.institution
  }
}

const mapDispatchToProps = (dispatch) => ({
  deleteClass: (classObj) => dispatch(deleteClass(classObj)),
  updateClass: (class_id, newData) => dispatch(updateClass(class_id, newData))
})

export default connect(mapStateToProps, mapDispatchToProps)(TimetableFormMobile);
